module.exports = __webpack_public_path__ + "img/cabin_w001.549fcec9.jpg";